//to capitalize the first letter of the word.
function capitalizeLetter(word: string | undefined) {
  const newWord = word && word[0]?.toUpperCase() + word?.slice(1);
  return newWord;
}

export { capitalizeLetter };
